import React from 'react'
import CategoryContainer from './CategoryContainer'

// A vertically-ordered list of category rows,
// where each row contains multiple tiles,
// and each tile can represent a single asset or a set of assets
// filtered within the row's category (e.g., a sub-category).
const CategoryList = ({
  processedNavigation,
  onThumbClick,
  onEditName,
  onDeleteCategory,
  onEditDocumentName,
  onDeleteDocument,
  addToLeftRefs,
  addToRightRefs
}) => {
  return (
    <div className="cat-container-level01">
      {processedNavigation?.map((superElm, superElmIdx) => {
        if (superElm.name !== `Uncategorized`) {
          return (
            <CategoryContainer
              key={'superCategory_' + superElmIdx}
              superElm={superElm}
              superElmIdx={superElmIdx}
              onThumbClick={onThumbClick}
              onEditName={onEditName}
              onDeleteCategory={onDeleteCategory}
              onEditDocumentName={onEditDocumentName}
              onDeleteDocument={onDeleteDocument}
              addToLeftRefs={addToLeftRefs}
              addToRightRefs={addToRightRefs}
            />
          )
        } else {
          return null
        }
      })}
    </div>
  )
}

export default CategoryList
